import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  isLoading?: boolean;
  loadingText?: string;
}

export default function Button({
  children,
  isLoading = false,
  loadingText = "Loading...",
  disabled,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      type="submit"
      disabled={disabled || isLoading}
      className={`bg-[#037897] w-full mt-10 py-4 text-white font-gilroy-bold uppercase rounded-[8px] disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...props}
    >
      {isLoading ? loadingText : children}
    </button>
  );
}
